import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';

export type ViewMode = 'grid' | 'list';

@Component({
  selector: 'app-view-toggle',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="flex items-center gap-1 bg-white border border-gray-200 rounded-lg p-1">
      <button
        (click)="setViewMode('grid'); saveState()"
        [class.bg-[#4A90E2]]="viewMode === 'grid'"
        [class.text-white]="viewMode === 'grid'"
        [class.text-gray-600]="viewMode !== 'grid'"
        class="p-2 rounded-md transition-colors hover:bg-gray-50 flex items-center justify-center"
        title="Visualização em grade"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <rect x="3" y="3" width="7" height="7" rx="1" stroke-width="2"/>
          <rect x="14" y="3" width="7" height="7" rx="1" stroke-width="2"/>
          <rect x="3" y="14" width="7" height="7" rx="1" stroke-width="2"/>
          <rect x="14" y="14" width="7" height="7" rx="1" stroke-width="2"/>
        </svg>
      </button>
      <button
        (click)="setViewMode('list'); saveState()"
        [class.bg-[#4A90E2]]="viewMode === 'list'"
        [class.text-white]="viewMode === 'list'"
        [class.text-gray-600]="viewMode !== 'list'"
        class="p-2 rounded-md transition-colors hover:bg-gray-50 flex items-center justify-center"
        title="Visualização em lista"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <line x1="3" y1="6" x2="21" y2="6" stroke-width="2" stroke-linecap="round"/>
          <line x1="3" y1="12" x2="21" y2="12" stroke-width="2" stroke-linecap="round"/>
          <line x1="3" y1="18" x2="21" y2="18" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  `,
})
export class ViewToggleComponent {
  @Input() viewMode: ViewMode = 'grid';
  @Output() viewModeChange = new EventEmitter<ViewMode>();

  setViewMode(mode: ViewMode): void {
    if (this.viewMode !== mode) {
      this.viewMode = mode;
      this.viewModeChange.emit(mode);
    }
  }

  // Save state in local storage
  saveState(): void {
    localStorage.setItem('viewMode', this.viewMode);
  }

  // Load state from local storage
  loadState(): void {
    this.viewMode = localStorage.getItem('viewMode') as ViewMode || 'grid';
  }

  // Initialize state
  ngOnInit(): void {
    this.loadState();
  }
}
